import type { ReactNode } from 'react';
import { useIsPsiStaff } from '../../utils/psiStaff';
import NoAccess from './NoAccess';

/**
 * Blocks a page for anyone but PSI staff (a psibuffalo.com login), whatever their role allows.
 * Pair it with the API's RequirePsiStaffAttribute, which is what actually enforces it.
 */
export default function PsiOnlyRoute({ feature, message, children }: { feature?: string; message?: string; children: ReactNode }) {
  if (!useIsPsiStaff()) return <NoAccess feature={feature} message={message} />;
  return <>{children}</>;
}
